import axiosClient from './axiosClient';

const sectionApi = {
  getAll: (boardId) => axiosClient.get(`boards/${boardId}/sections`),
  getOne: (boardId, sectionId) =>
    axiosClient.get(`boards/${boardId}/sections/${sectionId}`),
  create: (boardId) => axiosClient.post(`boards/${boardId}/sections`),
  update: (boardId, sectionId, params) =>
    axiosClient.put(`boards/${boardId}/sections/${sectionId}`, params),
  delete: (boardId, sectionId) =>
    axiosClient.delete(`boards/${boardId}/sections/${sectionId}`),
};

export default sectionApi;
